import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import Styles from './Styles'

const BaseLayout = ({ children }) => {
  const {
    site: { metadata }
  } = useStaticQuery(query)

  return (
    <>
      <Styles />
      <Helmet titleTemplate={metadata.titleTemplate}>
        <html lang="en" />
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:type" content={metadata.type} />
        <meta
          property="og:image"
          content={`${metadata.url}${metadata.image}`}
        />
        <meta property="og:image:width" content="2650" />
        <meta property="og:image:height" content="2650" />
        <meta property="fb:app_id" content={metadata.facebook.appId} />
        <link rel="icon" href="/images/favicon-32.png" sizes="32x32" />
        <link rel="icon" href="/images/favicon-128.png" sizes="128x128" />
        <link rel="icon" href="/images/favicon-192.png" sizes="192x192" />
        <link
          rel="apple-touch-icon"
          href="/images/favicon-152.png"
          sizes="152x152"
        />
        <link
          rel="apple-touch-icon"
          href="/images/favicon-167.png"
          sizes="167x167"
        />
        <link
          rel="apple-touch-icon"
          href="/images/favicon-180.png"
          sizes="180x180"
        />
        <link
          rel="shortcut icon"
          href="/images/favicon-196.png"
          sizes="196x196"
        />
      </Helmet>
      {children}
    </>
  )
}

export default BaseLayout

const query = graphql`
  query Metadata {
    site {
      metadata: siteMetadata {
        title
        titleTemplate
        description
        type
        url
        image
        facebook {
          appId
        }
      }
    }
  }
`
